import { render } from "./SearchAutocompleteDesktop.vue?vue&type=template&id=425f5c0c"
import script from "./SearchAutocompleteDesktop.vue?vue&type=script&lang=js"
export * from "./SearchAutocompleteDesktop.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/app/components/SearchAutocompleteDesktop.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "425f5c0c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('425f5c0c', __exports__)) {
    api.reload('425f5c0c', __exports__)
  }
  
  module.hot.accept("./SearchAutocompleteDesktop.vue?vue&type=template&id=425f5c0c", () => {
    api.rerender('425f5c0c', render)
  })

}


export default __exports__